module.exports = {
  '1': {
    q: 'Per cosa utilizzi lo strumento?',
    a: {
      0: 'Hobby',
      1: 'Collezionismo',
      2: 'Lavoro',
      3: 'Strumento di proprietà della scuola'
    }
  },
  '1_1': {
    q: 'Quanti concerti vengono effettuati in un anno con lo strumento?',
    a: {
      0: 'Nessuno',
      1: 'Meno di 10',
      2: 'Tra 10 e 20',
      3: 'Tra 20 e 40',
      4: 'Oltre 40'
    }
  },
  '1_2': {
    q: 'Dove vengono svolti i concerti?',
    a: {
      0: 'Solo in Italia',
      1: "Anche nei paesi dell'unione europea",
      2: 'In tutto il mondo'
    }
  },
  '2': {
    q: 'Viene trasportato in apposite custodie?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  },
  '3': {
    q: 'Viene utilizzato da altre persone oltre al contraente?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  },

  '3_1': {
    q: 'Viene utilizzato da persone minori di 18 anni?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  },

  '3_2': {
    q: 'Chi utilizza lo strumento è un parente?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  },

  '4': {
    q: 'Lo strumento è già assicurato?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  },

  '4_1': {
    q: 'Con quale compagnia?',
    type: 'text'
  },

  '4_2': {
    q: 'Quando scade la polizza?',
    type: 'date'
  },

  '4_3': {
    q: 'Lo è stato in passato?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  },

  '4_3_1': {
    q: 'Con quale compagnia?',
    type: 'text'
  },

  '4_3_2': {
    q: 'Quando è scaduta la polizza?',
    type: 'date'
  },

  '4_3_3': {
    q: 'Perché non è stata rinnovata la polizza?',
    a: {
      0: 'Troppo Costosa',
      1: 'Altro'
    }
  },

  '5': {
    q: 'Lo strumento ha subito sinistri negli ultimi 5 anni?',
    a: {
      0: 'Sì',
      1: 'No'
    }
  }
};
